// Navbar.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../styles/navbar.css";
import { toggleCartSidebar } from "../redux/actions/cartActions";
import NavLinks from "./NavLinks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faTruck,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import SearchDropdown from "./SearchDropdown";
import { useMediaQuery } from "react-responsive";
import CartSidebar from "./CartSidebar";
import MishaafLogo from "./MishaafLogo";

const Navbar = () => {
  const dispatch = useDispatch();
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.user);
  const cartItems = useSelector((state) => state.cart.items || []);
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();
  useEffect(() => {
    // Fetch search suggestions on component mount
    dispatch({ type: "DATA_FILE_REQUEST" });
    // Mocked suggestions (replace with actual data)
    setSearchSuggestions([
      { value: "abaya set", label: "Abaya Set" },
      { value: "abayas all", label: "Abayas All" },
      { value: "open abayas", label: "Open Abayas" },
      { value: "front open abbayas", label: "Front Open Abbayas" },
    ]);
  }, [dispatch]);

  // Handle search input change
  const onSearch = (value) => {};
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const navigateToAuth = () => {
    isAuthenticated ? navigate("/account") : navigate("/login");
  };
  const handleTruckNavigation = () => {
    navigate("/myorders");
  };
  return (
  //  <div>
     <nav className="bg-white sticky top-0 z-50 mt-2  ">
      {/* <div className="rounded-[12px] " >
      <div className="flex justify-center mt-[15px] mb-[15px] ">
        <div className=" w-[40%] h-[13rem]  rounded-[12px] border-[1px] flex justify-center items-center border-gray-300 ">
       <div className="  flex justify-center bg-black  h-[12rem] w-[94%] rounded-[12px] " >
       <Link to="/">
          <img
            src="/assets/images/Mishaaf-icon.jpeg"
            alt="brand-logo"
            className="h-[12rem]"
            />
        </Link>
       </div>
            </div>
            </div>
      </div> */}
      <div className="container  flex items-center justify-between pb-3 pt-0 px-6">
        {/* Logo */}
        <div className="flex mt-1 ">
          {isMobile && (
            <button onClick={toggleSidebar} className="p-0 me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="16"
                viewBox="0 0 30 16"
                fill="currentColor"
              >
                <rect width="30" height="1.5"></rect>
                <rect y="7" width="20" height="1.5"></rect>
                <rect y="14" width="30" height="1.5"></rect>
              </svg>
            </button>
          )}
          <div></div>
          <div className="flex items-center  space-x-4">
            <Link to="/">
              <img
                src="/assets/images/Mishaaf-icon.jpeg"
                alt="brand-logo"
                className="h-16 w-[100px] rounded-[12px] "
              />
            </Link>
          </div>
          <span className=" flex items-center ml-4 text-[30px]  " ><strong>Mishaaf</strong></span>
        </div>

        {/* Search Input with Dropdown */}
        {!isMobile && (
          <div className="w-2/3 mx-6  ">
            <SearchDropdown
              searchSuggestions={searchSuggestions}
              onSearch={onSearch}
            />
          </div>
        )}

        {/* Icons */}
        <div className="flex items-center space-x-4">
          <span>
            <FontAwesomeIcon
              icon={faTruck}
              className="cursor-pointer"
              onClick={handleTruckNavigation}
            />
          </span>
          <span>
            <FontAwesomeIcon
              icon={faUser}
              onClick={navigateToAuth}
              className="cursor-pointer"
            />
          </span>
          <span className="relative">
            <img
              src="/assets/shopping-bag.svg"
              className="cursor-pointer h-5"
              onClick={() => dispatch(toggleCartSidebar())}
            />
            {/* Cart Count Badge */}
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-black text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </span>
        </div>
      </div>
      {isMobile && (
        <div className="m-4 mt-0">
          <SearchDropdown
            searchSuggestions={searchSuggestions}
            onSearch={onSearch}
          />
        </div>
      )}
      {/* Nav Links Section at the bottom */}
      <NavLinks
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <CartSidebar />
    </nav>
    // < MishaafLogo />
  //  </div>
  );
};
export default Navbar;